import axios from 'axios'

export default {
  // NOTE: http://stackoverflow.com/questions/7584794/
  // -2: not jpeg
  // -1: not defined
  getOrientationFromFile(file) {
    return new Promise((resolve, reject) => {
      let reader = new FileReader()
      reader.onload = e => {
        let view = new DataView(e.target.result)
        if (view.getUint16(0, false) != 0xffd8) return resolve(-2)
        let length = view.byteLength,
          offset = 2
        while (offset < length) {
          let marker = view.getUint16(offset, false)
          offset += 2
          if (marker == 0xffe1) {
            if (view.getUint32((offset += 2), false) != 0x45786966) return resolve(-1)
            let little = view.getUint16((offset += 6), false) == 0x4949
            offset += view.getUint32(offset + 4, little)
            let tags = view.getUint16(offset, little)
            offset += 2
            for (let i = 0; i < tags; i++)
              if (view.getUint16(offset + i * 12, little) == 0x0112)
                return resolve(view.getUint16(offset + i * 12 + 8, little))
          } else if ((marker & 0xff00) != 0xff00) break
          else offset += view.getUint16(offset, false)
        }
        resolve(-1)
      }
      reader.onerror = e => {
        reject(e)
      }
      reader.readAsArrayBuffer(file)
    })
  },

  // datauriをblobに変換
  base64toBlob(base64, type) {
    let bin = atob(base64.replace(/^.*,/, ''))
    let buffer = new Uint8Array(bin.length)
    for (let i = 0; i < bin.length; i++) {
      buffer[i] = bin.charCodeAt(i)
    }
    // Blobを作成
    let blob
    try {
      blob = new Blob([buffer.buffer], { type })
    } catch (e) {
      return false
    }
    return blob
  },

  // BlobをFileに変換
  blobToFile(blob, name) {
    blob.lastModifiedDate = new Date()
    blob.name = name
    return blob
  },

  // FileオブジェクトをURLに変換
  fileToUrl(fileObject) {
    return URL.createObjectURL(fileObject)
  },

  // datauriをFileに変換
  base64ToFile(base64, filename = 'image') {
    let newBlob = this.base64toBlob(base64, 'image/jpeg')
    return this.blobToFile(newBlob, `${filename}.jpg`)
  },

  // fileデータをbase64に変換する
  async fileUrlToBase64(fileUrl) {
    if (process.server) {
      return ''
    }
    return axios.get(fileUrl, { responseType: 'arraybuffer' }).then(response => {
      const base64ImagePrefix = 'data:image/png;base64'
      // arraybuffer to base64
      const base64Data = btoa(String.fromCharCode(...new Uint8Array(response.data)))
      return `${base64ImagePrefix},${base64Data}`
    })
  }
}
